"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreludeCard = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
class PreludeCard extends Card_1.Card {
    constructor(properties) {
        super({
            cardType: CardType_1.CardType.PRELUDE,
            name: properties.name,
            tags: properties.tags,
            metadata: properties.metadata,
            productionBox: properties.productionBox,
            resourceType: properties.resourceType,
            cardDiscount: properties.cardDiscount,
            tr: properties.tr,
        });
    }
    canPlay(_player) {
        return true;
    }
}
exports.PreludeCard = PreludeCard;
//# sourceMappingURL=PreludeCard.js.map